exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-da69e3b4] {\n  background: #ffa726 !important;\n}\n", ""]);

// exports
